module.exports = __webpack_public_path__ + "static/media/ic_share.1b9b7fc3.svg";